module.exports = __webpack_public_path__ + "img/all_categories.db020d03.svg";